import React from "react";
import { Box, Container, Typography } from "@mui/material";
import bgimg from "../../assets/images/service_bg.png";

const ForensicInvestigation = () => {
  return (
    <Box
      sx={{
        py: 8,
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            color: "#294b8c",
            fontWeight: 700,
            mb: 5,
            fontSize: { xs: "28px", md: "40px" },
            backgroundImage: `url(${bgimg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            px: 3,
            py: 8,
          }}
        >
          Forensic Investigation
        </Typography>

        {/* Content */}
        <Box
          sx={{
            maxWidth: "1050px",
            margin: "0 auto",
          }}
        >
          <Typography
            sx={{
              color: "#7a1f2b",
              fontSize: "16px",
              lineHeight: "1.9",
              mb: 3,
              textAlign: "left",
            }}
          >
            With over 30 years of specialization in this field, we bring an
            artful approach to deriving measurable results and conclusive
            evidence.
          </Typography>

          <Typography
            sx={{
              color: "#7a1f2b",
              fontSize: "16px",
              lineHeight: "1.9",
              mb: 3,
            }}
          >
            Our Forensic, Litigation, and Valuation Services (FLVS) Group offers
            comprehensive services, including forensic accounting, valuation,
            economic damages calculations, and expert testimony, contributing to
            successful resolutions of complex disputes. From courtroom battles
            to out-of-court settlements, our FLVS Group is equipped to handle a
            spectrum of forensic, litigation, and valuation requirements,
            providing holistic solutions tailored to each client’s unique needs.
          </Typography>

          <Typography
            sx={{
              color: "#7a1f2b",
              fontSize: "16px",
              lineHeight: "1.9",
              mb: 3,
            }}
          >
            We excel in handling assignments for multi-geographic,
            multi-platform organizations with turnovers of up to INR 1 trillion.
            Our proven track record demonstrates our capability to deliver
            success for diverse entities.
          </Typography>
          <Typography
            sx={{
              color: "#7a1f2b",
              fontSize: "16px",
              lineHeight: "1.9",
              mb: 3,
            }}
          >
            impactful, insightful & objective oriented. How we do this
            differently is understanding the objective of the acquisition or
            investment, then designing our due diligence plan, with the
            objective of bringing out meaningful insights about the company,
            which would equip the parties to get into the deal with confidence,
            confidence that they are aware of what to expect, of what the
            organization’s strengths are, confidence in planning & charting our
            collaborations, and identifying synergies.
          </Typography>
          <Typography
            sx={{
              color: "#7a1f2b",
              fontSize: "16px",
              lineHeight: "1.9",
              mb: 3,
            }}
          >
            Navigate business transactions with confidence and precision through
            our Financial Due Diligence services at Pipara. As experienced
            professionals, we are dedicated to providing insightful advisory and
            quality work, ensuring a thorough analysis of key business drivers
            and financial risks—all within the right timeline.
          </Typography>
          <Typography
            sx={{
              color: "#7a1f2b",
              fontSize: "16px",
              lineHeight: "1.9",
              mb: 3,
            }}
          >
            Our Financial Due Diligence services involve a comprehensive
            analysis of financial data, identifying key business drivers and
            potential risks. We delve into the intricate details to provide you
            with a clear understanding of the financial landscape, empowering
            you to make informed decisions. Beyond numbers, we provide strategic
            advisory services based on our findings. Our insights guide your
            negotiations, ensuring you pay the right price for a business and
            generate optimal returns for your investors.
          </Typography>
          <Typography
            sx={{
              color: "#7a1f2b",
              fontSize: "16px",
              lineHeight: "1.9",
              mb: 3,
            }}
          >
            At Pipara, we understand the critical role that Financial Due
            Diligence plays in shaping successful business transactions. Our
            approach is rooted in a meticulous analysis of the quality of
            earnings and assets, forming the bedrock of your valuation model. We
            go beyond the surface to uncover insights that guide your decisions
            and drive returns for your investors.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ForensicInvestigation;
